module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/merge-b249fde5bb36090d5787bbf73303565b.svg";